import { defaultPageImagePath } from '@gik/core/constants';

export function shouldShowPagePicture(url: string): boolean {
  return !url?.includes(defaultPageImagePath);
}
